// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"servicios-module--wrapper--2wCK3","info":"servicios-module--info--39OTM"};